<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate text-truncate">Cuenta de usuario: {{ this.username }}</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Usuarios', route: '/user' }, { label: this.username }]" />

      @defer (when this.isLoadingUser === false) {
        <div class="h-100">
          <p-button class="h-100" styleClass="h-100" icon="pi pi-ellipsis-v" (click)="menu.toggle($event)" variant="text" />
          <p-menu #menu [model]="userActionsMenu" [popup]="true" appendTo="body">
            <ng-template #item let-item>
              <a pRipple class="d-flex items-center p-menu-item-link">
                <span [class]="item.icon"></span>
                <span class="ml-2">{{ item.label }}</span>
                <span *ngIf="item.shortcut" class="bg-body-secondary border p-1 rounded small ms-auto">{{ item.shortcut }}</span>
              </a>
            </ng-template>
          </p-menu>
        </div>
        <p-button label="Guardar" icon="pi pi-save" class="h-100" styleClass="h-100" [loading]="isSaving" (onClick)="save()" [disabled]="!formUser.valid" />
        <!-- <p-button icon="pi pi-trash" aria-label="Delete" class="h-100" styleClass="h-100" severity="danger" [loading]="isDeleting" (onClick)="delete($event)" /> -->
      }
    </div>
  </section>

  <section wrapper>
    <form [formGroup]="formUser" [ngClass]="{ 'on-action-wait': this.isSaving === true || this.isDeleting === true }">
      <p-accordion [value]="['0', '3']" [multiple]="true">
        <p-accordion-panel value="0" class="mb-2">
          <p-accordion-header>Información de la cuenta de usuario.</p-accordion-header>
          <p-accordion-content>
            <div class="page-section card">
              @defer (when this.isLoadingUser === false) {
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-6 col-lg-4 col-xxl-3 mb-3 mb-xxl-0">
                      <div class="d-flex flex-column gap-2">
                        <input formControlName="firstName" type="text" pInputText class="w-100 h-50px" />
                        <small class="ps-2">Nombre(s) <span class="text-danger">Requerido *</span></small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 col-xxl-3 mb-3 mb-xxl-0">
                      <div class="d-flex flex-column gap-2">
                        <input formControlName="lastName" type="text" pInputText class="w-100 h-50px" />
                        <small class="ps-2">Apellidos <span class="text-danger">Requerido *</span></small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 col-xxl-3 mb-3 mb-sm-0 mb-xxl-0">
                      <div class="d-flex flex-column gap-2">
                        <input formControlName="nickname" type="text" pInputText class="w-100 h-50px" />
                        <small class="ps-2">Sobrenombre <span class="text-danger">Requerido *</span></small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-12 col-xxl-3">
                      <div class="d-flex flex-column gap-2">
                        <input formControlName="email" type="email" pInputText class="w-100 h-50px" placeholder="example@domain.com" />
                        <small class="ps-2">Correo electrónico <span class="text-danger">Requerido *</span></small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body border-top">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                      <div class="d-flex flex-column gap-2">
                        <p-password formControlName="password" styleClass="w-100" inputStyleClass="w-100 h-50px" [toggleMask]="true" autocomplete="new-password"></p-password>
                        <small class="ps-2">Contraseña</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="d-flex flex-column gap-2">
                        <p-password formControlName="rpassword" styleClass="w-100" inputStyleClass="w-100 h-50px" [toggleMask]="true" autocomplete="new-password"></p-password>
                        <small class="ps-2">Repetir contraseña</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body border-top">
                  <div class="row">
                    <div class="col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0">
                      <div class="d-flex flex-column gap-2">
                        <p-select
                          formControlName="role"
                          [options]="roles"
                          optionLabel="label"
                          optionValue="userRoleId"
                          [filter]="true"
                          filterBy="label"
                          placeholder="Selecciona el nivel de acceso"
                          class="w-100 h-50px"
                          appendTo="body"
                        />
                        <small class="ps-2">Rol del usuario <span class="text-danger">Requerido *</span></small>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="d-flex flex-column gap-2">
                        <p-multiSelect
                          formControlName="permissions"
                          [options]="permissions"
                          placeholder="Selecciona los permisos del usuario"
                          scrollHeight="250px"
                          display="chip"
                          styleClass="w-100 h-50px"
                          appendTo="body"
                        />
                        <small class="ps-2">Permisos asignados</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body border-top">
                  <div class="row">
                    <div class="col-12 col-md-6 col-xxl-3">
                      <div class="d-flex flex-column gap-2">
                        <p-inputnumber formControlName="numberSessions" [showButtons]="true" class="h-50px w-100" [step]="1" [min]="1" placeholder="Sin límite de sesiones" />
                        <small class="ps-2">Número de sesiones permitidas</small>
                      </div>
                    </div>
                  </div>
                </div>
              } @placeholder {
                <placeholder-card />
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="1" class="mb-2">
          <p-accordion-header>Número de acciones permitidas por módulo.</p-accordion-header>
          <p-accordion-content>
            <div class="page-section card">
              @defer (when this.isLoadingUser === false) {
                <div class="card-body p-0">
                  <p-tabView formGroupName="numberSharesAllowed" class="w-100" scrollable="true">
                    <p-tabPanel header="REGISTRO CIVIL">
                      <div class="p-3">
                        <div class="row g-4">
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Marcos, folios, reversos</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="REGISTRO_CIVIL_MARCOS_FOLIOS_REVERSOS"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.REGISTRO_CIVIL_MARCOS_FOLIOS_REVERSOS"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Buscar acto</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="REGISTRO_CIVIL_BUSCAR_ACTO"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.REGISTRO_CIVIL_BUSCAR_ACTO"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Digitalización</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="REGISTRO_CIVIL_DIGITALIZATION"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.REGISTRO_CIVIL_DIGITALIZATION"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Corrección de acta</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="REGISTRO_CIVIL_CORRECCION_ACTA"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.REGISTRO_CIVIL_CORRECCION_ACTA"
                              placeholder="Sin acciones"
                            />
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                    <p-tabPanel header="SAT">
                      <div class="p-3">
                        <div class="row g-4">
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Cambio de emisión</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_CAMBIO_EMISION"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_CAMBIO_EMISION"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Constancia de situación fiscal</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_CONSTANCIA_SITUACION_FISCAL"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_CONSTANCIA_SITUACION_FISCAL"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Opinion de cumplimiento</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_OPINION_CUMPLIMIENTO"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_OPINION_CUMPLIMIENTO"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Cédula de identificación fiscal</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_CEDULA_IDENTIFICACION_FISCAL"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_CEDULA_IDENTIFICACION_FISCAL"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Recuperación de CFDI</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_RECUPERACION_CFDI"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_RECUPERACION_CFDI"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Recuperación de declaración</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_RECUPERACION_DECLARACION"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_RECUPERACION_DECLARACION"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Cita para persona física</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_CITA_PERSONA_FISICA"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_CITA_PERSONA_FISICA"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Cita para persona moral</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_CITA_PERSONA_MORAL"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_CITA_PERSONA_MORAL"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Alta RFC por primera vez con contraseña</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Alta RFC por primera vez sin contraseña</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Contraseña CIEC con INE</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_CONTRASENA_CIEC_INE"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_CONTRASENA_CIEC_INE"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Restablecer contraseña</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="SAT_RESTABLECER_CONTRASENA"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.SAT_RESTABLECER_CONTRASENA"
                              placeholder="Sin acciones"
                            />
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                    <p-tabPanel header="IMSS">
                      <div class="p-3">
                        <div class="row g-4">
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Información NSS</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="IMSS_INFORMACION_NSS"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.IMSS_INFORMACION_NSS"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Consultar NSS</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="IMSS_CONSULTAR_NSS"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.IMSS_CONSULTAR_NSS"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Asignar correo electrónico a NSS</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="IMSS_ASIGNAR_CORREO_NSS"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.IMSS_ASIGNAR_CORREO_NSS"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Semanas cotizadas</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="IMSS_SEMANAS_COTIZADAS"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.IMSS_SEMANAS_COTIZADAS"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Vigencia de derecho</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="IMSS_VIGENCIA_DERECHO"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.IMSS_VIGENCIA_DERECHO"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>No derechohabiente</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="IMSS_NO_DERECHOHABIENTE"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.IMSS_NO_DERECHOHABIENTE"
                              placeholder="Sin acciones"
                            />
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                    <p-tabPanel header="RENAPO">
                      <div class="p-3">
                        <div class="row g-4">
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>CURP</b>
                            </p-divider>

                            <p-inputnumber formControlName="RENAPO_CURP" styleClass="w-100 h-50px" class="w-100 h-50px" [min]="0" [max]="shareLimit.RENAPO_CURP" placeholder="Sin acciones" />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Corrección de CURP</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="RENAPO_CORRECCION_CURP"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.RENAPO_CORRECCION_CURP"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Unificación de CURP</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="RENAPO_UNIFICACION_CURP"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.RENAPO_UNIFICACION_CURP"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Certificación de CURP</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="RENAPO_CERTIFICACION_CURP"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.RENAPO_CERTIFICACION_CURP"
                              placeholder="Sin acciones"
                            />
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                    <p-tabPanel header="ISSSTE">
                      <div class="p-3">
                        <div class="row g-4">
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Talón de pagos</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="ISSSTE_TALON_PAGOS"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.ISSSTE_TALON_PAGOS"
                              placeholder="Sin acciones"
                            />
                          </div>
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Constancia de acreditación de no afiliación</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="ISSSTE_CONSTANCIA_ACREDITACION_AFILIACION"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.ISSSTE_CONSTANCIA_ACREDITACION_AFILIACION"
                              placeholder="Sin acciones"
                            />
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                    <p-tabPanel header="CFE">
                      <div class="p-3">
                        <div class="row g-4">
                          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column gap-2">
                            <p-divider align="left" class="m-0">
                              <b>Recibo de Luz</b>
                            </p-divider>

                            <p-inputnumber
                              formControlName="CFE_RECIBO_DE_LUZ"
                              styleClass="w-100 h-50px"
                              class="w-100 h-50px"
                              [min]="0"
                              [max]="shareLimit.CFE_RECIBO_DE_LUZ"
                              placeholder="Sin acciones"
                            />
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                  </p-tabView>
                </div>
              } @placeholder {
                <placeholder-card />
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="2" class="mb-2">
          <p-accordion-header>Información de los costos.</p-accordion-header>
          <p-accordion-content>
            <div class="page-section card">
              @defer (when this.isLoadingUser === false) {
                <div class="card-body p-0">
                  <p-tabView formGroupName="prices" class="w-100" scrollable="true">
                    <p-tabPanel header="REGISTRO CIVIL" formGroupName="REGISTRO_CIVIL">
                      <div class="p-3 d-flex flex-column gap-4">
                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Digitalización</b>
                          </p-divider>

                          <p-inputnumber formControlName="DIGITALIZACION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Corrección acta</b>
                          </p-divider>

                          <p-inputnumber formControlName="CORRECCION_ACTA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Marcos, folios y reversos</b>
                          </p-divider>

                          <p-inputnumber formControlName="MARCO_FOLIO_REVERSO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>
                      </div>

                      <div class="p-3 d-flex flex-column gap-4">
                        <div formGroupName="BUSCAR_ACTO">
                          <p-divider align="left" class="m-0">
                            <b>Buscar acto</b>
                          </p-divider>
                          <ng-container *ngFor="let estado of Object.keys(formUser.get('prices.REGISTRO_CIVIL.BUSCAR_ACTO')?.value || {})">
                            <div class="mb-2">
                              <p-fieldset legend="{{ formatEstadoName(estado) }}">
                                <div [formGroupName]="estado" class="d-flex flex-column flex-xl-row gap-2">
                                  <p-inputgroup>
                                    <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Nacimiento</span></p-inputgroup-addon>
                                    <p-inputnumber formControlName="NACIMIENTO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" min="0" />
                                  </p-inputgroup>
                                  <p-inputgroup>
                                    <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Matrimonio</span></p-inputgroup-addon>
                                    <p-inputnumber formControlName="MATRIMONIO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                                  </p-inputgroup>
                                  <p-inputgroup>
                                    <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Defunción</span></p-inputgroup-addon>
                                    <p-inputnumber formControlName="DEFUNCION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                                  </p-inputgroup>
                                  <p-inputgroup>
                                    <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Divorcio</span></p-inputgroup-addon>
                                    <p-inputnumber formControlName="DIVORCIO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                                  </p-inputgroup>
                                </div>
                              </p-fieldset>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </p-tabPanel>

                    <p-tabPanel header="SAT" formGroupName="SAT">
                      <div class="p-3 d-flex flex-column gap-4">
                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Cambio de emisión</b>
                          </p-divider>
                          <p-inputnumber formControlName="CAMBIO_EMISION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Cédula de identificación fiscal</b>
                          </p-divider>
                          <p-inputnumber formControlName="CEDULA_IDENTIFICACION_FISCAL" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Cita persona física</b>
                          </p-divider>
                          <p-inputnumber formControlName="CITA_PERSONA_FISICA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Constancia de situación fiscal</b>
                          </p-divider>
                          <p-inputnumber formControlName="CONSTANCIA_SITUACION_FISCAL" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Opinión del cumplimiento</b>
                          </p-divider>
                          <p-inputnumber formControlName="OPINION_CUMPLIMIENTO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Recuperación de CFDI</b>
                          </p-divider>
                          <p-inputnumber formControlName="RECUPERACION_CFDI" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Recuperación de declaración</b>
                          </p-divider>
                          <p-inputnumber formControlName="RECUPERACION_DECLARACION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Cita persona moral</b>
                          </p-divider>
                          <p-inputnumber formControlName="CITA_PERSONA_MORAL" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Alta RFC primera vez con contraseña</b>
                          </p-divider>
                          <p-inputnumber formControlName="ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Alta RFC primera vez sin contraseña</b>
                          </p-divider>
                          <p-inputnumber formControlName="ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Contraseña CIEC con INE</b>
                          </p-divider>
                          <p-inputnumber formControlName="CONTRASENA_CIEC_INE" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>
                      </div>
                    </p-tabPanel>

                    <p-tabPanel header="IMSS" formGroupName="IMSS">
                      <div class="p-3 d-flex flex-column gap-4">
                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Consultar NSS</b>
                          </p-divider>
                          <p-inputnumber formControlName="CONSULTAR_NSS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Información NSS</b>
                          </p-divider>
                          <p-inputnumber formControlName="INFORMACION_NSS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Asignar correo NSS</b>
                          </p-divider>
                          <p-inputnumber formControlName="ASIGNAR_CORREO_NSS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Semanas cotizadas</b>
                          </p-divider>
                          <p-inputnumber formControlName="SEMANAS_COTIZADAS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Vigencia derecho</b>
                          </p-divider>
                          <p-inputnumber formControlName="VIGENCIA_DERECHO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>No derechohabiente</b>
                          </p-divider>
                          <p-inputnumber formControlName="NO_DERECHOHABIENTE" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>
                      </div>
                    </p-tabPanel>

                    <p-tabPanel header="RENAPO" formGroupName="RENAPO">
                      <div class="p-3 d-flex flex-column gap-4">
                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>CURP</b>
                          </p-divider>
                          <p-inputnumber formControlName="CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Corrección de CURP</b>
                          </p-divider>
                          <p-inputnumber formControlName="CORRECCION_CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Unificación de CURP</b>
                          </p-divider>
                          <p-inputnumber formControlName="UNIFICACION_CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Certificación de CURP</b>
                          </p-divider>
                          <p-inputnumber formControlName="CERTIFICACION_CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>
                      </div>
                    </p-tabPanel>

                    <p-tabPanel header="ISSSTE" formGroupName="ISSSTE">
                      <div class="p-3 d-flex flex-column gap-4">
                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Talón de pagos</b>
                          </p-divider>
                          <p-inputnumber formControlName="TALON_PAGOS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Constancia de acreditación de no afiliación</b>
                          </p-divider>
                          <p-inputnumber formControlName="CONSTANCIA_ACREDITACION_NO_AFILIACION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>
                      </div>
                    </p-tabPanel>

                    <p-tabPanel header="CFE" formGroupName="CFE">
                      <div class="p-3 d-flex flex-column gap-4">
                        <div class="d-flex flex-column gap-2">
                          <p-divider align="left" class="m-0">
                            <b>Recibo de Luz</b>
                          </p-divider>
                          <p-inputnumber formControlName="RECIBO_DE_LUZ" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                        </div>
                      </div>
                    </p-tabPanel>
                  </p-tabView>
                </div>
              } @placeholder {
                <placeholder-card />
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="3" class="mb-2">
          <p-accordion-header>Información de la sesiones.</p-accordion-header>
          <p-accordion-content>
            <div class="page-section card">
              @defer (when this.isLoadingSessions === false) {
                <p-table #dt1 [value]="sessions" [rows]="5" [rowsPerPageOptions]="[5, 10, 20]" [paginator]="true">
                  <ng-template pTemplate="body" let-item>
                    <tr>
                      <td>
                        <p class="card-title">
                          <strong class="fw-medium">{{ item.firstName }}</strong> ha iniciado sesión desde {{ item.metadata.os }}.
                        </p>
                        <p class="card-text">
                          <small
                            >Creada {{ item.dateCreated | date: "medium" }}, Dirección IP {{ item.metadata.ip }}, Navegador {{ item.metadata.browser }}, UserAgent {{ item.metadata.userAgent }}.</small
                          >
                        </p>
                      </td>
                      <td class="text-center" style="width: 100px">
                        <p-tag [value]="item.status === 'ACTIVE' ? 'Activa' : 'Inactiva'" [severity]="item.status === 'ACTIVE' ? 'success' : 'secondary'" class="fw-normal" />
                      </td>
                      <td style="width: 50px">
                        <div ngbDropdown placement="top-end" container="body" class="d-inline-block">
                          <button type="button" class="btn btn-outline-primary border-0 p-2" ngbDropdownToggle>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                            </svg>
                          </button>
                          <div ngbDropdownMenu class="p-2 border-0 shadow-lg">
                            <button ngbDropdownItem class="d-flex align-items-center gap-2" [disabled]="item.status !== 'ACTIVE'" (click)="logout(item); item.status = 'INACTIVE'">
                              <i class="bi bi-box-arrow-right fs-4"></i> <small>Cerrar sesión</small>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="3">No se encontraron registros.</td>
                    </tr>
                  </ng-template>
                </p-table>
              } @placeholder {
                <placeholder-table />
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </form>
  </section>
</backbone>
